import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    vertical: {
        flexDirection: "column"
    },
    container: {
        alignItems: "stretch",
        isolation: "isolate"
    },
    stretch: {
        alignSelf: "stretch",
        width: "100%"
    },
    horizontal: {
        flexDirection: "row"
    }
});
export default stylesheet;
